import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {TREND_THEMES} from '../../../constants/trend-themes';
import Loader from '../../euro-2020/components/loader';
import {FIFA_TOP_FORWARDS} from '../../euro-2020/constants/fifa2022/top-forwards';
import {Theme} from '../../euro-2020/contexts/theme';
import {fetchData} from '../../euro-2020/utils/helpers';

import TopForwardsList from './top-forwards-list';

import styles from './widget-top-forwards.module.css';

const TOP_FORWARDS_NUMBER = 10;

const WidgetTopForwards = () => {
  const [data, setData] = useState({topForwards: [], isLoading: true});
  const theme = useContext(Theme);
  const {t} = useTranslation();

  useEffect(async() => {
    if (theme === TREND_THEMES.FIFA) {
      return setData({
        topForwards: FIFA_TOP_FORWARDS,
        isLoading: false
      });
    }

    try {
      setData({...data, isLoading: true});

      const topForwards = await fetchData({
        url: 'football/worldcup-2022/top-forwards'
      });

      setData({
        topForwards: topForwards.slice(0, TOP_FORWARDS_NUMBER),
        isLoading: false
      });
    } catch (e) {
      setData({...data, isLoading: false});
    }
  }, []);

  if (data.isLoading) {
    return <Loader color='#fff' />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t('fifa2022.topForwardsWidget.title')}
      </div>
      {!data.topForwards.length
        ? (
          <div className={styles.placeholder}>
            {t('fifa2022.topForwardsWidget.placeholder')}
          </div>
        ) : <TopForwardsList topForwards={data.topForwards} />}
    </div>
  );
};

export default WidgetTopForwards;
